




// light 版本仅支持 svg 渲染器，体积更小
import lottie from 'lottie-web/build/player/lottie_light'
import Vue from 'vue'
import { isPromiseLike } from 'vtils'
import type { AnimationItem } from 'lottie-web'

export default Vue.extend({
  inheritAttrs: false,

  props: {
    data: {
      type: Object,
      required: true,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    loop: {
      type: Boolean,
      default: true,
    },
    fit: {
      type: String,
      default: 'contain',
    },
  },

  data: () => ({
    lottie: null as any as AnimationItem,
  }),

  async mounted() {
    const data = isPromiseLike(this.data)
      ? await this.data.then(
          res => (res && typeof res === 'object' && res.default) || res,
        )
      : this.data
    this.lottie = lottie.loadAnimation({
      container: this.$el,
      loop: this.loop,
      autoplay: this.autoplay,
      renderer: 'svg',
      animationData: data,
      rendererSettings: {
        preserveAspectRatio:
          this.fit === 'contain' ? 'xMidYMid meet' : 'xMidYMid slice',
      },
    })
    if (this.autoplay) {
      this.startProgress()
    }
  },

  beforeDestroy() {
    if (this.lottie) {
      this.lottie.destroy()
      this.lottie = null as any
    }
  },

  methods: {
    startProgress() {
      this.clearProgress()
      if (!this.loop) {
        const duration = this.lottie.getDuration() * 1000
        ;(this as any)._progress =
          !(this as any)._progress || (this as any)._progress >= duration
            ? 0
            : (this as any)._progress
        const emit = () => {
          ;(this as any)._progress += 60
          const progress = Math.min((this as any)._progress / duration, 1)
          if (progress === 1) {
            this.clearProgress()
          }
          this.$emit('progress', progress)
        }
        ;(this as any)._timer = setInterval(emit, 60)
        emit()
      }
    },
    clearProgress() {
      clearInterval((this as any)._timer)
    },
    play() {
      this.lottie?.play()
      this.startProgress()
    },
    pause() {
      this.clearProgress()
      this.lottie?.pause()
    },
    stop() {
      this.clearProgress()
      this.lottie?.stop()
    },
    replay() {
      this.clearProgress()
      this.play()
    },
  },
})
